<template>
    <div class="stages mb-2 d-flex justify-content-around position-relative">
        <div class="stage-connect"></div>
        <div
            v-for="st in statuses"
            :key="st"
            class="stage"
            :class="{ active: request.approval[st] }"
            :data-tooltip="`${st} : ${day(request.approval[st]).format('MMM DD YYYY H:mm A')}`">
            <span v-if="request.approval[st]">{{ day(request.approval[st]).format('DD/M') }}</span>
            <span v-else class="font-weight-bold text-success"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Stage",
    props: {
        request: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            statuses: ['authorized_at', 'approved_at', 'verified_at', 'disbursed_at']
        }
    }
}
</script>

<style scoped>
.stages {
    width: 75%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.stage {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: white;
    font-size: 8px;
    font-weight: bolder;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    border: 1px solid #ddd;
    transition: background-color 0.3s, color 0.3s;
    cursor: pointer;
    text-transform: uppercase;
}

.stage.active {
    color: #333 !important;
    background-color: #efefef;
}

.stage::after {
    content: attr(data-tooltip);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(100%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    white-space: nowrap;
    font-size: 12px;
    text-transform: uppercase;
    display: none;
    z-index: 1;
}

.stage:hover::after {
    display: block;
}

.stage-connect {
    height: 3px;
    background-color: #eee;
    position: absolute;
    width: calc(100% - 40px);
    top: 50%;
    left: 20px;
    z-index: 0;
}

@media only screen and (max-width: 480px) {
    .stage {
        width: 30px;
        height: 30px;
        font-size: 6px;
    }
}
</style>
